export default {
      id: "icon-quote-usage",
      viewBox: "0 0 116 115",
      url: __webpack_public_path__ + "icons.svg#icon-quote",
      toString: function () {
        return this.url;
      }
    }